<template>
    <div class="search_bar">
        <input v-model="searchInput" type="text" placeholder="검색어를 입력해 주세요.">
        <button type="button" @click="getSearchInputResult(searchInput)">검색</button>
    </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'SearchBar',
  data () {
    return {
      searchInput: ''
    }
  },
  computed: {
    ...mapState(['searchWord', 'searchInfo'])
  },
  mounted () {
    if (this.$route.path === '/search') {
      this.searchInput = ''
    } else {
      this.searchInput = this.$store.state.searchWord
    }
  },
  methods: {
    getSearchInputResult (searchWord) {
      console.log('clicked')
      if (searchWord === '' || searchWord === null) {
        this.$store.state.searchWord = ''
        this.$router.push('/search')
      } else {
        this.$store.state.searchWord = searchWord
        this.$router.push('/searchResult').catch(() => {})
      }
    }
  }
}
</script>
